module.exports = __webpack_public_path__ + "img/THDataJP.de47cbff.png";